export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/textAnalyzer.worker.4fd4d727.worker.js");
}
